import * as React from 'react';
import { connect } from 'react-redux';
import { ChangeEvent } from 'react';
import './LiabilitySlider.css';
import DispatchProps, { mapDispatchToProps } from '../../application/core/DispatchProps';
import ValueFromSliderChanged from '../../application/order/events/ValueFromSliderChanged';

interface SliderStyles {
    point: { left: string };
    liabilityValue: { left: string };
    range: { width: string };
}

interface State {
    value: number;
}

class LiabilitySlider extends React.PureComponent<DispatchProps, State> {
    constructor(props: DispatchProps) {
        super(props);
        this.state = {
            value: 0
        };
    }

    public render(): JSX.Element {
        const slideStyle: SliderStyles = this.genSlideStyle(this.state.value);
        return (
            <div className="range">
                <span className="range-value" style={slideStyle.range} />
                <span className="circle" style={slideStyle.point} />
                <span className="circle-value" style={slideStyle.liabilityValue}>
                    {this.state.value}
                </span>
                <input
                    className="range-slide"
                    name="range"
                    type="range"
                    min="0"
                    max="100"
                    value={this.state.value}
                    step="5"
                    onChange={this.handleChange}
                    onMouseUp={this.onMouseUp}
                />
            </div>
        );
    }

    private handleChange = (e: ChangeEvent<HTMLInputElement>): void => {
        this.setState({ value: Number(e.target.value) });
    };

    private onMouseUp = (): void => {
        this.props.dispatch(new ValueFromSliderChanged(this.state.value));
    };

    private genSlideStyle = (value: number): SliderStyles => {
        return {
            point: {
                left: `calc(${value}% - 1px)`
            },
            liabilityValue: {
                left: `calc(${value}% - 3px)`
            },
            range: {
                width: `${value}%`
            }
        };
    };
}

export default connect(mapDispatchToProps)(LiabilitySlider);



// WEBPACK FOOTER //
// ./src/view/order/LiabilitySlider.tsx